import gtagModule from './gtag.module'
export default gtagModule.name

/**
 * @typedef {import('./gtag.service').default} GtagWrapper
 * @typedef {import('./analytics.service').default} AnalyticsService
 */
